var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPresent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M160-80v-440H80v-240h208q-5-9-6.5-19t-1.5-21q0-50 35-85t85-35q23 0 43 8.5t37 23.5q17-16 37-24t43-8q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h208v240h-80v440zm400-760q-17 0-28.5 11.5T520-800t11.5 28.5T560-760t28.5-11.5T600-800t-11.5-28.5T560-840m-200 40q0 17 11.5 28.5T400-760t28.5-11.5T440-800t-11.5-28.5T400-840t-28.5 11.5T360-800M160-680v80h280v-80zm280 520v-360H240v360zm80 0h200v-360H520zm280-440v-80H520v80z"
})));
export default SvgPresent;